import { Grid, Typography } from '@mui/material';
import React from 'react';

export function getVideoDetails(content) {
  if (!content.fields?.videoUrl?.match(/vimeo\.com/)) {
    return {
      Body: () => <Typography variant="h5">There was an issue loading your video.</Typography>,
      title: 'Video loading error',
    };
  }

  let vimeoId = content.fields?.videoUrl.replace(/.+?vimeo\.com\//, '');
  const urlParams = {
    badge: 0,
    autopause: 0,
    player_id: 0,
    app_id: 58479,
  };

  if (vimeoId.match(/.+\/.+/)) {
    urlParams.h = vimeoId.split('/')[1];
    vimeoId = vimeoId.split('/')[0];
  }

  const embedLink = `https://player.vimeo.com/video/${vimeoId}?${new URLSearchParams(urlParams).toString()}`;
  const title = content.fields?.title?.replace(/video/i, '').trim() || 'Missing video title';

  return {
    Body: () => (
      <>
        <Grid
          size={1}
          maxWidth="800px"
          margin="auto"
        >
          <Typography variant="h3">{title}</Typography>
        </Grid>
        <Grid
          size={8}
          flexGrow={8}
          minHeight="600px"
          height="600px"
          width="100%"
          margin="20px 0"
        >
          <iframe
            src={embedLink}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
            style={{
              width: '100%',
              height: '100%',
            }}
            title={title}
          ></iframe>
        </Grid>
        <Grid
          size={1}
          maxWidth="800px"
          margin="auto"
        >
          <Typography variant="body1">{content.fields?.videoDetails}</Typography>
        </Grid>
      </>
    ),
    title,
  };
}
